export default __webpack_public_path__ + "static/media/HAZZ.658b78dd.png";